module.exports = __webpack_public_path__ + "img/23.88116186.png";